'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoFieldBase = function (_Component) {
	_inherits(GeckoFieldBase, _Component);

	function GeckoFieldBase() {
		_classCallCheck(this, GeckoFieldBase);

		return _possibleConstructorReturn(this, (GeckoFieldBase.__proto__ || Object.getPrototypeOf(GeckoFieldBase)).apply(this, arguments));
	}

	_createClass(GeckoFieldBase, [{
		key: 'handleChange',


		// prepareAttrs(attrs) {
		// 	const defaults = {
		// 		id             : this.renderId(),
		// 		[`aria-label`] : this.renderAriaLabel(),
		// 		disabled       : this.isDisabled(),
		// 		onChange       : this.handleChange.bind(this),
		// 		onBlur         : this.handleBlur.bind(this),
		// 		placeholder    : this.config().placeholder || this.field().placeholder
		// 	};

		// 	return Object.assign({}, defaults, attrs || {});
		// }

		value: function handleChange(event) {
			return this.props.handler.bind(this, this.field().key, this.prepareValue(event.target.value))();
		}
	}, {
		key: 'handleBlur',
		value: function handleBlur(event) {
			if (this.props.field.onBlur) return this.props.field.onBlur(event);
			return;
		}
	}, {
		key: 'prepareValue',
		value: function prepareValue(value) {
			return value;
		}
	}, {
		key: 'prepareJsonValue',
		value: function prepareJsonValue(key, value) {
			var _value = this.jsonValue();
			_value[key] = value;
			return _value;
		}
	}, {
		key: 'field',
		value: function field() {
			return this.props.field;
		}
	}, {
		key: 'value',
		value: function value() {
			// get nested object values from a key like 'nested.object.value' to target {nested: {object: {value: 'test'}}}
			var keyFragments = this.field().key.split('.');
			var getValue = function getValue(obj, key) {
				return obj[key];
			};
			return keyFragments.reduce(getValue, this.props.values);
		}
	}, {
		key: 'jsonValue',
		value: function jsonValue() {
			if (this.value() && _typeof(this.value()) === 'object') return this.value();
			// Default value
			var value = {};
			(this.inputs || []).forEach(function (input) {
				return value[input.key] = '';
			});
			return value;
		}
	}, {
		key: 'renderId',
		value: function renderId() {
			return 'field_' + this.field().key;
		}
	}, {
		key: 'renderAriaLabel',
		value: function renderAriaLabel() {
			return this.field().label;
		}
	}, {
		key: 'isDisabled',
		value: function isDisabled() {
			return this.field().disabled || (this.field().disabledWhen ? this.field().disabledWhen() : false);
		}
	}, {
		key: 'options',
		value: function options() {
			return this.field().options && Array.isArray(this.field().options) ? this.field().options : [];
		}
	}, {
		key: 'config',
		value: function config() {
			return this.field().config || {};
		}
	}]);

	return GeckoFieldBase;
}(_react.Component);

GeckoFieldBase.propTypes = {
	field: _propTypes2.default.shape(_.GeckoFieldModel).isRequired
};

exports.default = GeckoFieldBase;